import { Tag, TagMap } from '../../../../../../../common/tags/tagTypes';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { selectTags, selectTagPaths } from '../../../../../../element/tags/tagSelectors';

export type UseTagPopupsStateReturn = {
    allTags: Tag[];
    currentlyEditingTag: Tag | null;
    setCurrentlyEditingTagId: (tagId: string | null) => void;
    userRootPath: ImMNElement[];
    shareRootPath: ImMNElement[];
    handleClickEdit: (tag: Tag) => void;
};

const useTagPopupsState = (toggleModal: (isOpen: boolean) => void): UseTagPopupsStateReturn => {
    const [currentlyEditingTagId, setCurrentlyEditingTagId] = useState<string | null>(null);

    const rootPaths = useSelector(selectTagPaths);
    const { userRootPath, shareRootPath } = rootPaths || {};

    const tags: TagMap | undefined = useSelector(selectTags);
    const currentlyEditingTag = tags?.[currentlyEditingTagId || ''] || null;

    const allTags = Object.values(tags || {});

    const handleClickEdit = (tag: Tag) => {
        setCurrentlyEditingTagId(currentlyEditingTagId == tag.id ? null : tag.id);
        toggleModal(currentlyEditingTagId !== tag.id);
    };

    return {
        allTags,
        currentlyEditingTag,
        setCurrentlyEditingTagId,
        userRootPath,
        shareRootPath,
        handleClickEdit,
    };
};

export default useTagPopupsState;
